<template>
  <div class="home">
    <div style="text-align:right;margin-bottom:10px"><Button size="small" @click="$router.go(-1)">返回</Button></div>
    <Row style="line-height:3;max-height:600px;overflow:auto">
      <Col span='24'><img style="width:300px" :src="path + details.avatar" alt=""></Col>
      <Col span='24'>姓名：{{ details.real_name }}</Col>
      <Col span='24'>头衔：{{ details.curse_title }}</Col>
      <Col span='24' v-html="details.instro">
      </Col>
      <Col span='24'><img style="width:300px" v-for="(item, i) in details.certificate" :key="i" :src="path + item" alt="">
      </Col>

    </Row>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        details: {},
      };
    },
    activated() {
      this.$axios
        .get("/app/teacher/index?id=" + this.$route.query.id)
        .then((res) => {
          this.details = res.data;
          this.details.certificate = res.data.certificate ? res.data.certificate.split(',') : []
        });
    },
    methods: {
    },
  };
</script>

<style lang="less" scoped>
  .home {
    width: 96%;
    margin: 0 auto 10px;
    min-height: 50vh;
  }
</style>
